import React, { useEffect, useState } from "react";
import { Button, Modal, Card, Row, Col, Container } from "react-bootstrap";
import Headerpackages from "../../components/Header/Headerpackages";
import { useLoading } from "../../contexts/LoadingContext";
import Swal from "sweetalert2";
import "../Dashboard/Dashboard.css";

const AllSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [serviceToUnsubscribe, setServiceToUnsubscribe] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isLoading, setIsLoading } = useLoading();

  // Define service names based on API keys
  const serviceNameMap = {
    API_HBS: "Health Bundle Service",
    API_MIS: "Mobile insurance Service",
    API_HIS: "Health insurance Service",
    API_ABS: "Agri Bundle Service",
    API_LIS: "Livestock Issurance Service",
    API_LBS: "Life Bundle Service",
    API_AS: "Agri Service",
    API_CIS: "Crop insurance Service",
    API_THS: "Tele Health Service",
    API_LS: "Legal Service",
    API_VS: "Veternary Service",
    API_HCB: "Health Card",
    API_HCW: "Women Health Card",
    API_IP: "Income Protection",
    API_RSA_BIKE: "RSA Bike Service",
    API_RSA_CAR: "RSA Car Service",
    API_RSA_BI: "RSA Bike Insurance",
    API_RSA_CI: "RSA Car Insurance",
  };

  // Fetch subscriptions from API
  const fetchSubscriptions = async () => {
    const msisdn = JSON.parse(sessionStorage.getItem("msisdn"));
    const requestBody = {
      msisdn: msisdn,
    };
    try {
      setIsLoading(true);
      setLoading(true);
      const response = await fetch(
        "https://digital.webdoc.com.pk/Promotion/public/api/v1/service/get-all-subscription",
        {
          method: "POST",
          body: JSON.stringify(requestBody),
        }
      );
      const data = await response.json();

      if (data.statusCode === "0000") {
        // Merge all subscription types into one array
        const allSubscriptions = [];
        const serviceKeys = [
          "API_HBS",
          "API_MIS",
          "API_HIS",
          "API_ABS",
          "API_LIS",
          "API_LBS",
          "API_AS",
          "API_CIS",
          "API_THS",
          "API_LS",
          "API_VS",
          "API_HCB",
          "API_HCW",
          "API_IP",
          "API_RSA_BIKE",
          "API_RSA_CAR",
          "API_RSA_BI",
          "API_RSA_CI",
        ];

        serviceKeys.forEach((key) => {
          if (data.payLoad[key]) {
            // Add the service name based on the key
            const services = data.payLoad[key].map((service) => ({
              ...service,
              service_name: serviceNameMap[key] || "Unknown Service",
              api_service: key, // Store the API key dynamically
            }));
            allSubscriptions.push(...services);
          }
        });

        setSubscriptions(allSubscriptions);
      } else {
        setSubscriptions([]);
      }
    } catch (error) {
      console.error("Error fetching subscriptions", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while fetching subscriptions.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const handleUnsubscribe = async (service) => {
    console.log("Unsubscribing from", service);
    setShowUnsubscribeModal(false);
    try {
      // Static `msisdn` for now
      const msisdn = JSON.parse(sessionStorage.getItem("msisdn"));

      // Confirm before unsubscribing
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to unsubscribe from ${service.service_name}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, unsubscribe",
        cancelButtonText: "Cancel",
      });

      if (!confirmResult.isConfirmed) return;

      // API call for unsubscribing
      const response = await fetch(
        "https://digital.webdoc.com.pk/Promotion/public/api/v1/service/un-subscribe",
        {
          method: "POST",
          body: JSON.stringify({
            api_service: service.api_service, // Use the dynamic `api_service` from the service object
            msisdn,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to unsubscribe");
      }

      const data = await response.json();

      // Check for success
      if (data.statusCode === 100 && data.payLoad?.IS_UN_SUB === "Y") {
        const result = await Swal.fire({
          title: "Unsubscribed!",
          text: data.payLoad.message,
          icon: "success",
          allowOutsideClick: false,
          confirmButtonText: "OK",
        });
        if (result.isConfirmed) {
          // After unsubscribing, refresh subscriptions list
          fetchSubscriptions();
        }
      } else {
        await Swal.fire({
          title: "Error",
          text: data.statusMessage.join(", "),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error during unsubscribe:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while unsubscribing. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <h2>Loading subscriptions...</h2>
      </div>
    );
  }

  return (
    <>
      <Headerpackages
        title={`<span style="color:#8cc63e; font-weight:600;">All</span> Subscription`}
      />

      <Container className="overflow-hidden">
        {subscriptions.length > 0 && (
          <Row className="my-2">
            <Col>
              <p>Here are the services you are currently subscribed to:</p>
            </Col>
          </Row>
        )}

        {/* Subscription Cards */}
        <Row>
          {subscriptions.length === 0 ? (
            <Col className="text-center">
              <p>No active subscriptions found.</p>
            </Col>
          ) : (
            subscriptions.map((subscription, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                {/* <Card>
                  <Card.Body>
                    <Card.Title>
                      {subscription.service_name || "Service Name"}{" "}
                    </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      {subscription.status === "100" ? "Active" : "Inactive"}
                    </Card.Subtitle>
                    <Card.Text>
                      <strong>Subscription Date:</strong>{" "}
                      {subscription.sub_dt || "N/A"}
                      <br />
                      <strong>Last Charge Date:</strong>{" "}
                      {subscription.last_charge_dt || "N/A"}
                      <br />
                      <strong>Next Charge Date:</strong>{" "}
                      {subscription.next_charge_dt || "N/A"}
                    </Card.Text>
                    <Button
                      style={{ backgroundColor: "#8cc63e" }}
                      onClick={() => handleUnsubscribe(subscription)} // Pass the correct subscription object
                      className="w-100 subscription-button"
                    >
                      Unsubscribe
                    </Button>
                  </Card.Body>
                </Card> */}

                {/* ========================== */}

                <Card
                  className="custom-card"
                  style={{
                    borderRadius: "20px",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <Card.Body>
                    <div className="row">
                      <div className="col-8">
                        <h5>{subscription.service_name || "Service Name"} </h5>

                        <p className="badge bg-info text-dark">
                          Sub Mode: {subscription.sub_mode || "N/A"}
                        </p>
                      </div>
                      <div className="col-4">
                        <div className="d-flex justify-content-end align-items-end">
                          <span className="badge bg-success text-white">
                            {subscription.status === "100"
                              ? "Active"
                              : "Inactive"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row date-bar">
                      <div className="col-6">
                        <strong>Subscription Date:</strong>
                        <div>{subscription.sub_dt || "N/A"}</div>
                      </div>
                      <div className="col-6">
                        <strong>Next Charge Date:</strong>
                        <div>{subscription.next_charge_dt || "N/A"}</div>
                      </div>
                    </div>
                    <Button
                      style={{ backgroundColor: "#8cc63e" }}
                      onClick={() => handleUnsubscribe(subscription)} // Pass the correct subscription object
                      className="w-100 subscription-button"
                    >
                      Unsubscribe
                    </Button>
                    <style>
                      {`
                                .date-bar {
                                  display: flex;
                                  justify-content: space-between;
                                  align-items: center;
                                  background-color: #e0e0e0;
                                  border-radius: 20px;
                                  padding: 10px 15px;
                                  margin-top: 10px;
                                }
                                .date-bar div {
                                  flex: 1;
                                  text-align: center;
                                }
                              `}
                    </style>
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>
    </>
  );
};

export default AllSubscriptions;
